import React from 'react';
import PropTypes from 'prop-types';
import Number from "Components/Properties/Inputs/Number";

export default class CoOrdinate extends React.Component
{
    static propTypes = {
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,

        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    render()
    {
        return <div className="mt-1 relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 text-sm">{this.props.label}</span>
            </div>
              <Number
                className="block w-full pl-7 text-sm"
                value={this.props.value}
                onChange={this.props.onChange}
                onBlur={this.props.onBlur}
            />
        </div>;
    }
}